import type { SVGProps } from 'react';
const SvgIconDisclosureRightSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.338 12.394a.75.75 0 0 1-.074-1.058L8.67 8 6.264 4.664a.75.75 0 0 1 1.132-.985l3.33 3.829a.75.75 0 0 1 0 .984l-3.33 3.829a.75.75 0 0 1-1.058.073"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDisclosureRightSmall;
